import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { authHeader } from "../../services/auth-header";
import { BASE_URL } from "../../services/Api";
import Form from "react-bootstrap/Form";
import { Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import EditPumpDomesticQuotation from "./PumpDomesticQuotation/EditPumpDomesticQuotation";
import EditPumpInternationalQuotation from "./PumpInternationalQuotation/EditPumpInternationalQuotation";
import EditAraiMfgQuoation from "./AraiMfgQuotation/EditAraiMfgQuotation";
import EditAraiMfgDomesticQuotation from "./AraiMfgDomesticSQ/EditAraiMfgDomesticSQ";

const EditSOQuotation = () => {
  const { id, pointindex } = useParams();
  const [productType, setProductType] = useState();
  const [productCategory, setProductCategory] = useState();
  const [enquiryData, setEnquiryData] = useState();

  async function getData() {
    try {
      const response = await axios.get(`${BASE_URL}quotation/findById/${id}`, {
        headers: authHeader(),
      });

      console.log(response);
      setEnquiryData(response.data);
      setProductType(response.data.quotationtype);
      setProductCategory(response.data.quotationcategory);
    } catch (error) {
      console.log(error);
    }
  }

  function PageDisplay() {
    if (productType === "Pump Spare") {
      if (productCategory === "Domestic") {
        return <EditPumpDomesticQuotation enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditPumpInternationalQuotation enquiryData={enquiryData} id={id} />;
      }
    } else if (productType === "Manufacturing") {
      if (productCategory === "Domestic") {
        return <EditAraiMfgDomesticQuotation enquiryData={enquiryData} />;
      } else if (productCategory === "International") {
        return <EditAraiMfgQuoation enquiryData={enquiryData} />;
      }
    } else {
      return null;
    }
  }

  useEffect(() => {
    getData();
  }, []);

  console.log(enquiryData);

  return (
   
      <Card className="card">
        <Card.Header className="card-header">
          <h6>Edit Quotation</h6>
          <Link to={`/quotationIndexTable/${pointindex}`}>
            <button className="button-70">BACK</button>
          </Link>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Quotation Type:</Form.Label>
                <Form.Select
                  onChange={(e) => {
                    setProductType(e.target.value);
                  }}
                  value={productType}
                  disabled={productType ? true : false}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Quotation Category:</Form.Label>
                <Form.Select
                  disabled={
                    !productType
                      ? true
                      : false || productCategory
                        ? true
                        : false
                  }
                  value={productCategory}
                  onChange={(e) => setProductCategory(e.target.value)}
                >
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>

            {PageDisplay()}
          </Row>
        </Card.Body>
      </Card>
  );
};

export default EditSOQuotation;
